<template>
    <div>
        <van-popup v-model="show" position="bottom" round :style="{ height: '70%' }">
            <div class="management-label">
                <!-- 标题栏 -->
                <div class="header">
                    <span class="title">标签管理</span>
                    <van-icon name="cross" @click="$hide" />
                </div>

                <!-- 新增标签输入区 -->
                <div class="add-section">
                    <van-field
                        v-model="newTagName"
                        placeholder="请输入标签名称"
                        clearable
                    />
                    <van-button type="primary" size="small" @click="handleAddTag">新增</van-button>
                </div>

                <!-- 标签列表 -->
                <div class="tag-list">
                    <List 
                        v-model="loading" 
                        :finished="finished" 
                        :error="loadError" 
                        :error-text="loadErrorText"
                        finished-text="没有更多了" 
                        @load="onLoad"
                    >
                        <div class="tag-item" v-for="item in tagList" :key="item.id">
                            <div class="tag-info">
                                <van-tag type="primary" size="medium">{{ item.name }}</van-tag>
                                <span class="tag-count">{{ item.user_count || 0 }}人使用</span>
                            </div>
                            <div class="tag-actions">
                                <van-button 
                                    type="info" 
                                    size="mini" 
                                    plain
                                    @click="handleEditTag(item)"
                                >编辑</van-button>
                                <van-button 
                                    type="danger" 
                                    size="mini" 
                                    plain
                                    @click="handleDeleteTag(item)"
                                >删除</van-button>
                            </div>
                        </div>
                    </List>
                </div>
            </div>
        </van-popup>

        <!-- 编辑标签弹窗 -->
        <van-dialog
            v-model="editDialogShow"
            title="编辑标签"
            show-cancel-button
            @confirm="handleUpdateTag"
        >
            <van-field
                v-model="editTagName"
                placeholder="请输入新的标签名称"
                clearable
            />
        </van-dialog>
    </div>
</template>
<script>
import { addTag, deleteTag, updateTag, getTagList } from '@/api/channelCode';
import { List } from 'vant';
export default {
    name: 'managementLabel',
    components: {
        List
    },
    data() {
        return {
            show: false,
            tagList: [],
            newTagName: '',
            editDialogShow: false,
            editTagName: '',
            currentEditTag: null,
            page: 0,
            loading: false,
            finished: false,
            loadError: false,
            loadErrorText: ''
        }
    },
    methods: {
        $show() {
            this.show = true;
            // 重置分页数据
            this.page = 0;
            this.tagList = [];
            this.finished = false;
            this.loadError = false;
        },
        $hide() {
            this.show = false;
            this.newTagName = '';
        },
        // List组件的加载方法
        onLoad() {
            console.log("onLoad 标签列表");
            this.page++;
            this.getTagList();
        },
        // 获取标签列表
        getTagList() {
            let _this = this;
            this.loading = true;
            getTagList({
                page: this.page,
                limit: 10
            }).then(res => {
                console.log('标签列表:', res);
                if (res.code === 1) {
                    const list = res.data.list || res.data || [];
                    _this.tagList = [...this.tagList, ...list];
                    // 判断是否还有更多数据
                    if (list.length < 10) {
                        _this.finished = true;
                    }
                } else {
                    _this.loadError = true;
                    _this.loadErrorText = res.msg || '获取标签列表失败';
                }
            }).catch(err => {
                console.error('获取标签列表失败:', err);
                _this.loadError = true;
                _this.loadErrorText = '获取标签列表失败';
            }).finally(() => {
                this.$nextTick(() => {
                    _this.loading = false;
                });
            });
        },
        // 刷新列表
        refreshList() {
            // 重置列表数据
            this.page = 0;
            this.tagList = [];
            this.finished = false;
            this.loadError = false;
            this.onLoad();
        },
        // 新增标签
        handleAddTag() {
            if (!this.newTagName.trim()) {
                this.$toast.fail('标签名称不能为空');
                return;
            }
            
            // 检查标签是否已存在
            const exists = this.tagList.some(tag => tag.name === this.newTagName.trim());
            if (exists) {
                this.$toast.fail('标签已存在');
                return;
            }

            addTag({
                name: this.newTagName.trim()
            }).then(res => {
                console.log('新增标签:', res);
                if (res.code === 1) {
                    this.$toast.success('新增标签成功');
                    this.newTagName = '';
                    this.refreshList();
                    // 通知父组件刷新标签列表
                    this.$emit('refresh');
                } else {
                    this.$toast.fail(res.msg || '新增标签失败');
                }
            }).catch(err => {
                console.error('新增标签失败:', err);
                this.$toast.fail('新增标签失败');
            });
        },
        // 编辑标签
        handleEditTag(item) {
            this.currentEditTag = item;
            this.editTagName = item.name;
            this.editDialogShow = true;
        },
        // 更新标签
        handleUpdateTag() {
            if (!this.editTagName.trim()) {
                this.$toast.fail('标签名称不能为空');
                return;
            }

            // 检查标签名称是否与其他标签重复
            const exists = this.tagList.some(tag => 
                tag.name === this.editTagName.trim() && tag.id !== this.currentEditTag.id
            );
            if (exists) {
                this.$toast.fail('标签名称已存在');
                return;
            }

            updateTag({
                id: this.currentEditTag.id,
                name: this.editTagName.trim()
            }).then(res => {
                console.log('更新标签:', res);
                if (res.code === 1) {
                    this.$toast.success('更新标签成功');
                    this.editDialogShow = false;
                    this.refreshList();
                    // 通知父组件刷新标签列表
                    this.$emit('refresh');
                } else {
                    this.$toast.fail(res.msg || '更新标签失败');
                }
            }).catch(err => {
                console.error('更新标签失败:', err);
                this.$toast.fail('更新标签失败');
            });
        },
        // 删除标签
        handleDeleteTag(item) {
            this.$dialog.confirm({
                title: '删除确认',
                message: `确定要删除标签"${item.name}"吗？`,
                confirmButtonText: '确定',
                confirmButtonColor: '#ee0a24',
                cancelButtonText: '取消',
            }).then(() => {
                deleteTag({
                    id: item.id
                }).then(res => {
                    console.log('删除标签:', res);
                    if (res.code === 1) {
                        this.$toast.success('删除标签成功');
                        this.refreshList();
                        // 通知父组件刷新标签列表
                        this.$emit('refresh');
                    } else {
                        this.$toast.fail(res.msg || '删除标签失败');
                    }
                }).catch(err => {
                    console.error('删除标签失败:', err);
                    this.$toast.fail('删除标签失败');
                });
            }).catch(() => {
                // 取消删除
            });
        }
    }
}
</script>
<style lang="less" scoped>
.management-label {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
}
/deep/ .van-field__control {
  color: #000000 !important;
  background: transparent !important;
}
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--base-px-16);
    border-bottom: 1px solid #f0f0f0;
    
    .title {
        font-size: var(--base-px-16);
        font-weight: bold;
        color: #333;
    }
    
    .van-icon {
        font-size: var(--base-px-20);
        color: #666;
        cursor: pointer;
    }
}

.add-section {
    display: flex;
    align-items: center;
    gap: var(--base-px-12);
    padding: var(--base-px-16);
    border-bottom: 1px solid #f0f0f0;
    
    .van-field {
        flex: 1;
        background: #f7f8fa;
        border-radius: var(--base-px-4);
    }
}

.tag-list {
    flex: 1;
    overflow-y: auto;
    padding: var(--base-px-12);
}

.tag-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--base-px-12);
    margin-bottom: var(--base-px-8);
    background: #f7f8fa;
    border-radius: var(--base-px-8);
    
    &:last-child {
        margin-bottom: 0;
    }
}

.tag-info {
    display: flex;
    align-items: center;
    gap: var(--base-px-12);
    flex: 1;
    
    .tag-count {
        font-size: var(--base-px-12);
        color: #999;
    }
}

.tag-actions {
    display: flex;
    gap: var(--base-px-8);
}

// 编辑弹窗内的输入框样式
.van-dialog {
    .van-field {
        margin: var(--base-px-16) 0;
    }
}
</style>